import { createTheme } from "@mui/material/styles";

/** Paleta alineada al panel admin (SideDrawer, Cobranza, Clientes). */
export const PRAMI_COLORS = {
  primary: "#161e55",
  primaryContrast: "#ffffff",
  hoverMint: "#A8C8AF",
  drawerNavy: "#1C224C",
  drawerHover: "#343A5F",
  sageSelected: "#a7d2a9",
  sageOnSage: "#1C224C",
  secondaryGreen: "#2e7d32",
  tableHeaderAlt: "#1e3a5f",
  pageBg: "#f5f6fa",
  surfaceBorder: "#e3e6ef",
  rowHighlight: "#e8f5e9",
};

export const pramiCertificadosTheme = createTheme({
  palette: {
    primary: {
      main: PRAMI_COLORS.primary,
      contrastText: PRAMI_COLORS.primaryContrast,
    },
    secondary: {
      main: PRAMI_COLORS.secondaryGreen,
      contrastText: "#ffffff",
    },
    success: {
      main: PRAMI_COLORS.sageSelected,
      contrastText: PRAMI_COLORS.sageOnSage,
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          "&.Mui-selected": {
            color: PRAMI_COLORS.primary,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: PRAMI_COLORS.primary,
          height: 3,
        },
      },
    },
  },
});
